import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers";


//配置 Redux store
const store = configureStore({
    reducer: {
        auth: authReducer, //模块化Reducer
    },
});

export default store;